"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const webapi_1 = require("@fegobull/webapi");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const index_vue_1 = tslib_1.__importDefault(require("../components/Container/index.vue"));
const index_vue_2 = tslib_1.__importDefault(require("../components/Main/index.vue"));
const use_1 = require("./use");
// 定义URL映射对象的类型
const __sfc_main = {};
__sfc_main.props = {
    actSign: {
        type: String,
        default: ''
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { useBehaviour } = webapi_1.use;
    const { runBehaviour } = useBehaviour();
    const props = __props;
    const { state } = (0, use_1.usePrizeList)(props.actSign);
    const handleClick = (url) => {
        runBehaviour(null, {
            value: url,
            type: 'link',
            withQuery: true
        });
    };
    return {
        state,
        handleClick
    };
};
__sfc_main.components = Object.assign({
    Component: index_vue_1.default,
    Main: index_vue_2.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXgudnVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5kZXgudnVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLDZDQUF1QztBQUN2Qyw2REFBNkQ7QUFDN0QsMEZBQTBEO0FBQzFELHFGQUFnRDtBQUNoRCwrQkFBcUM7QUFFckMsZUFBZTtBQUNmLE1BQU0sVUFBVSxHQUFHLEVBQUUsQ0FBQztBQUN0QixVQUFVLENBQUMsS0FBSyxHQUFHO0lBQ2pCLE9BQU8sRUFBRTtRQUNQLElBQUksRUFBRSxNQUFNO1FBQ1osT0FBTyxFQUFFLEVBQUU7S0FDWjtDQUNGLENBQUM7QUFDRixVQUFVLENBQUMsS0FBSyxHQUFHLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxFQUFFO0lBQ3BDLE1BQU0sRUFDSixZQUFZLEVBQ2IsR0FBRyxZQUFHLENBQUM7SUFDUixNQUFNLEVBQ0osWUFBWSxFQUNiLEdBQUcsWUFBWSxFQUFFLENBQUM7SUFDbkIsTUFBTSxLQUFLLEdBQUcsT0FBTyxDQUFDO0lBQ3RCLE1BQU0sRUFDSixLQUFLLEVBQ04sR0FBRyxJQUFBLGtCQUFZLEVBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2hDLE1BQU0sV0FBVyxHQUFHLENBQUMsR0FBVyxFQUFFLEVBQUU7UUFDbEMsWUFBWSxDQUFDLElBQUksRUFBRTtZQUNqQixLQUFLLEVBQUUsR0FBRztZQUNWLElBQUksRUFBRSxNQUFNO1lBQ1osU0FBUyxFQUFFLElBQUk7U0FDaEIsQ0FBQyxDQUFDO0lBQ0wsQ0FBQyxDQUFDO0lBQ0YsT0FBTztRQUNMLEtBQUs7UUFDTCxXQUFXO0tBQ1osQ0FBQztBQUNKLENBQUMsQ0FBQztBQUNGLFVBQVUsQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQztJQUNwQyxTQUFTLEVBQVQsbUJBQVM7SUFDVCxJQUFJLEVBQUosbUJBQUk7Q0FDTCxFQUFFLFVBQVUsQ0FBQyxVQUFVLENBQUMsQ0FBQztBQUMxQixrQkFBZSxVQUFVLENBQUMifQ==